export default function Footer() {
  return (
    <footer className="footer">
      Sistema Único - Imobiliárias • ERP para imobiliárias com busca por perfil
    </footer>
  );
}
